import { http } from 'msw';

import {
	finalizeDocument,
	generateDraft,
	getDocument,
	getPreviewPdf,
	getVersions,
	revertDocument,
	updateDocument,
} from './resolvers/documents.resolver';
import { getDocumentsResolver } from './resolvers/get-documents.resolver';

const _PREFIX = '*/v1';

const documentRoutes = {
	documents: `${_PREFIX}/documents`,
	byPolicyId: `${_PREFIX}/documents/by-policy-id/:policyId`,
	finalize: `${_PREFIX}/documents/by-policy-id/:policyId/finalize`,
	revert: `${_PREFIX}/documents/by-policy-id/:policyId/revert-to-draft`,
	previewPdf: `${_PREFIX}/documents/by-policy-id/:policyId/preview-pdf`,
	generateDraft: `${_PREFIX}/documents/by-policy-id/:policyId/generate-draft`,
	versions: `${_PREFIX}/documents/by-policy-id/:policyId/versions`,
};

const handlers = [
	http.get(documentRoutes.documents, getDocumentsResolver),
	http.get(documentRoutes.previewPdf, getPreviewPdf),
	http.get(documentRoutes.versions, getVersions),
	http.get(documentRoutes.byPolicyId, getDocument),
	http.patch(documentRoutes.byPolicyId, updateDocument),
	http.post(documentRoutes.finalize, finalizeDocument),
	http.post(documentRoutes.revert, revertDocument),
	http.post(documentRoutes.generateDraft, generateDraft),
];

export default handlers;
